import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var UnderlineIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5652 2C11.1848 2 11.6872 2.50083 11.6872 3.11864V25.7302C11.6872 32.5103 17.199 38.0054 23.9998 38.0054C30.8006 38.0054 36.3124 32.5103 36.3124 25.7302V3.11864C36.3124 2.50083 36.8148 2 37.4345 2C38.0541 2 38.5565 2.50083 38.5565 3.11864V25.7302C38.5565 33.7459 32.04 40.2427 23.9998 40.2427C15.9596 40.2427 9.44311 33.7459 9.44311 25.7302V3.11864C9.44311 2.50083 9.94547 2 10.5652 2Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7998 44.8814C8.7998 44.2635 9.30216 43.7627 9.92185 43.7627H38.0778C38.6974 43.7627 39.1998 44.2635 39.1998 44.8814C39.1998 45.4992 38.6974 46 38.0778 46H9.92185C9.30216 46 8.7998 45.4992 8.7998 44.8814Z"
  }));
});
UnderlineIcon.displayName = 'UnderlineIcon';
UnderlineIcon.defaultProps = {
  'aria-label': 'Underline'
};
export default UnderlineIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/UnderlineIcon/index.js
// module id = 1965
// module chunks = 12